import type { Tool, ToolSet } from 'ai';
import type { AiTool } from './types';

export const aiToolRegistry: AiTool<unknown, unknown, unknown>[] = [];

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function registerAiTool(aiTool: AiTool<any, any, any>) {
  const existingIndex = aiToolRegistry.findIndex((t) => t.id === aiTool.id);
  if (existingIndex >= 0) {
    // Replace existing tool (supports HMR - updated tool definitions take effect)
    aiToolRegistry[existingIndex] = aiTool;
  } else {
    aiToolRegistry.push(aiTool);
  }
}

export function getAiTool(id: string): AiTool<unknown, unknown, unknown> | undefined {
  return aiToolRegistry.find((aiTool) => aiTool.id === id);
}

export function getAiTools(): ToolSet {
  return Object.fromEntries(aiToolRegistry.map((aiTool) => [aiTool.id, aiTool.tool]));
}

export function getSelectedAiTools(toolNames: string[]): ToolSet {
  const selectedTools = aiToolRegistry.reduce(
    (acc, aiTool) => {
      if (toolNames.includes(aiTool.id)) {
        acc.push([aiTool.id, aiTool.tool]);
      }
      return acc;
    },
    [] as [string, Tool][],
  );

  return Object.fromEntries(selectedTools);
}

export function getAiToolNames(): string[] {
  return aiToolRegistry.map((aiTool) => aiTool.id);
}
